import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FactoryNodeInterfaceConfig, generateFactoryNodeInterfaceDefinition } from '@prism/prism-shared';

@Pipe({
    name: 'factoryNodeInterfaceConfigToString'
})

export class FactoryNodeInterfaceConfigToStringPipe implements PipeTransform {


    constructor(
        private sanitizer: DomSanitizer,
    ) { }


    transform(value: FactoryNodeInterfaceConfig): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(generateFactoryNodeInterfaceDefinition(value));
    }
}